// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ce951e2b","453":"b52abb1d","667":"4e6af73f","977":"868be1e0"}[chunkId] + ".chunk.js";
};